const DEBUG = process.env.REACT_APP_DEBUG === 'false';

export const REQUEST_URL = DEBUG
  ? 'http://localhost:9000/'
  : 'https://apib.trademarktrans.com/';